module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "d_modal",
    staticClass: "modal-wrapper no-print",
    class: [{
      'js-no-close': _vm.appendToBody
    }, {
      'modal-wrapper--from-top': _vm.placeInTop
    }],
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal",
    style: ({
      top: !_vm.placeInTop ? '0px' : _vm.pxFromTop + 'rem'
    })
  }, [(_vm.showClose) ? _c('div', {
    staticClass: "close-cross",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })]) : _vm._e(), _vm._v(" "), _vm._t("insertComponent", function() {
    return [_c('h2', [_vm._v("Hello")])]
  })], 2), _vm._v(" "), (_vm.isBgOverlay) ? _c('div', {
    staticClass: "bg-overlay animateFast fadeIn",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('close')
      }
    }
  }) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4549b0c6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DModal.vue
// module id = 1576
// module chunks = 1